<div [mobiTracking]="{ type: 'webfrom', id: entity().id, name: entity().bundle }">
  <mobi-webform [webformId]="entity().id" [params]="params()" />
</div>
